<template>
  <v-card>
    <v-card-title>
      Functions Dojo
    </v-card-title>
    <v-card-text>
      <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>En enkel howto :-)</v-expansion-panel-header>
        <v-expansion-panel-content>
      <p class="mt-4">
        För att implementera en funktion för att testa funktionsanrop mot backend behövs följande steg göras:
      </p>
      <p>
        <ul>
          <li>I /src/plugins/api.js lägger du till själva anropet mot url:en på din server.</li>
        </ul>
      </p>
      <p>
        Exempel:<br/>
<pre><code v-pre class="ma-4 pa-2">
  settings() {
    return this.apiClient.get(this.baseUrl + '/api/v1')
  },
</code></pre>
      </p>
      <p>
        <ul>
          <li>I /src/pages/FunctionDojo.vue lägger du till dels knappen som skickar iväg anropet och en funktion som anropar API:et.</li>
        </ul>
      </p>
      <p>
        Exempel:<br/>
<pre><code v-pre class="ma-4 pa-2">
  &lt;p&gt;
    &lt;v-btn&gt;
      color="secondary"
      @click="viewSettings"
    &gt;API/V1&lt;/v-btn&gt;
  &lt;p&gt;
</code></pre>
        samt:<br/>
<pre><code v-pre class="ma-4 pa-2">
  viewSettings () {
    API.settings()
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  },
</code></pre>
      </p>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    </v-card-text>

    <v-card-title>
      Funktioner
    </v-card-title>

    <v-card-text>
      <p>
        <v-btn
          color="secondary"
          @click="viewSettings"
        >API/V1</v-btn>
      </p>
      <p>
        <v-btn
          color="secondary"
          @click="viewRights"
        >API/V1/RIGHTS</v-btn>
      </p>
      <p>
        <v-btn
          color="secondary"
          @click="viewProfile"
        >API/V1/PROFILE</v-btn>
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import API from '@/plugins/api'

export default {
  data: () => ({
  }),

  methods: {
    viewSettings () {
      API.settings()
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
    },

    viewRights () {
      API.rights()
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
    },

    viewProfile () {
      API.profile()
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
</style>